let aliyunCaptchaScriptPromise = null

function ensureAliyunCaptchaGlobalConfig(config = {}) {
  if (typeof window === 'undefined') return
  if (!window.AliyunCaptchaConfig) {
    window.AliyunCaptchaConfig = {
      region: config.region || 'cn',
      prefix: config.prefix || '904xr7',
    }
  }
}

function loadAliyunCaptchaScript(globalConfig) {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Aliyun captcha only works in browser'))
  }
  ensureAliyunCaptchaGlobalConfig(globalConfig)
  if (window.initAliyunCaptcha) return Promise.resolve()
  if (aliyunCaptchaScriptPromise) return aliyunCaptchaScriptPromise

  aliyunCaptchaScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = 'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js'
    script.async = true
    script.setAttribute('data-aliyun-captcha', '1')
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Aliyun captcha script load failed'))
    document.head.appendChild(script)
  })

  return aliyunCaptchaScriptPromise
}

let elementCounter = 0

function createCaptchaContainer() {
  elementCounter += 1
  const id = `aliyun-captcha-el-${elementCounter}`
  const el = document.createElement('div')
  el.id = id
  document.body.appendChild(el)
  return {
    selector: `#${id}`,
    destroy() {
      if (el.parentNode) el.parentNode.removeChild(el)
    },
  }
}

/**
 * 触发一次无痕验证，返回验签参数。
 * 总站 encryptSceneId 拿到的是 EncryptedSceneId，必须单独传入；
 * 不能塞进 SceneId，否则 captcha-open 会返回 IllegalScene。
 *
 * 流程：
 *   1. initAliyunCaptcha → getInstance 拿实例
 *   2. instance.show() + instance.startTracelessVerification()
 *   3. 无痕验证可能失败（测试模式必失败）→ SDK 自动弹出滑块二次验证
 *   4. fail 回调只是 "无痕失败要降级"，不代表最终失败，所以不 reject
 *   5. 只有 success 才 resolve，代表最终验证通过
 * @param {object} options
 * @param {string} [options.sceneId] 控制台明文场景 ID
 * @param {string} [options.EncryptedSceneId] 服务端加密场景 ID
 */
export async function verifyAliyunCaptcha(options = {}) {
  if (typeof window === 'undefined') {
    throw new Error('Aliyun captcha only works in browser')
  }

  const {
    sceneId = 'd697xneh', // 控制台明文场景 ID，与 prefix 904xr7 配套
    EncryptedSceneId,
    language = 'en',
    slideWidth = 360,
    slideHeight = 40,
    region = 'cn',
    prefix = '904xr7',
  } = options

  await loadAliyunCaptchaScript({ region, prefix })

  const container = createCaptchaContainer()

  return new Promise((resolve, reject) => {
    let captchaInstance = null
    let settled = false
    let closeTimer = null

    function settle(fn) {
      if (settled) return
      settled = true
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null }
      container.destroy()
      fn()
    }
    const myLang = {
      en: {
        POPUP_TITLE: "Please complete captcha",
        CHECK_BOX_TIP: "Please confirm that you are not a robot"
      },
    }
    const captchaParams = {
      delayBeforeSuccess: false,
      SceneId: sceneId,
      mode: 'popup',
      element: container.selector,
      language,
      myLang,
      slideStyle: {
        width: slideWidth,
        height: slideHeight,
      },
      success(captchaVerifyParam) {
        settle(() => resolve(captchaVerifyParam))
      },
      fail() {

      },
      onClose() {
        settle(() => reject(new Error('Captcha closed by user')))
      },
      getInstance(instance) {
        captchaInstance = instance
        if (typeof captchaInstance.show === 'function' &&
            typeof captchaInstance.startTracelessVerification === 'function') {
          captchaInstance.show()
          captchaInstance.startTracelessVerification()
        } else {
          settle(() => reject(new Error('Aliyun captcha API missing: show / startTracelessVerification')))
        }
      },
    }
    // 加密模式：明文 SceneId 与 EncryptedSceneId 同时传，SDK 用加密串做校验
    if (EncryptedSceneId) {
      captchaParams.EncryptedSceneId = EncryptedSceneId
    }
    window.initAliyunCaptcha(captchaParams)
  })
}
